/**
 * Malia Mills — Booking Drawer
 * File: assets/fit-session-drawer.js
 *
 * Two drawer instances are created:
 *   FitSessionDrawer  — store appointments
 *   TrunkShowDrawer   — trunk show appointments
 *
 * Trigger:
 *   <button onclick="FitSessionDrawer.open('madison-ave')">Book a Fitting</button>
 *   <button onclick="TrunkShowDrawer.open('fannie-b')">Book an Appointment</button>
 */

(function () {
  'use strict';

  var PROXY_BASE_URL = 'https://soft-butterfly-e28b.sophie-9ea.workers.dev';

  // ─── STORE LISTS ───────────────────────────────────────────────────────────
  var FIT_SESSION_STORES = [
    {
      id: 'madison-ave',
      name: 'Madison Avenue',
      eventTypeUri: 'https://api.calendly.com/event_types/82f737c2-b091-4014-8146-24a19feb874d',
      location: '1070 Madison Avenue, New York, NY 10011',
      timezone: 'America/New_York',
    },
    {
      id: 'soho',
      name: 'SoHo',
      eventTypeUri: 'https://api.calendly.com/event_types/5cc5ea4d-cb67-4634-af85-06fa82a2b7ad',
      location: '27 Wooster St, New York, NY 10013',
      timezone: 'America/New_York',
    },
    {
      id: 'bridgehampton',
      name: 'Bridgehampton',
      eventTypeUri: 'https://api.calendly.com/event_types/045e07c2-9837-458f-822c-ca91b696423a',
      location: '2487 Main St, Bridgehampton, NY 11238',
      timezone: 'America/New_York',
    },
    {
      id: 'los-angeles',
      name: 'Los Angeles',
      eventTypeUri: 'https://api.calendly.com/event_types/1b54be21-9b1e-4da4-bbc4-489295218694',
      location: '1129 Montana Ave, Santa Monica, CA 90402',
      timezone: 'America/Los_Angeles',
    },
    {
      id: 'marin',
      name: 'Marin Country Mart',
      eventTypeUri: 'https://api.calendly.com/event_types/934110f6-bb7e-42d0-be1e-c7b211ff8e3c',
      location: 'Marin Country Mart - 2203 Larkspur Landing Cir, Larkspur, CA 94939',
      timezone: 'America/Los_Angeles',
    },
    {
      id: 'montecito',
      name: 'Montecito',
      eventTypeUri: 'https://api.calendly.com/event_types/4af2584a-cbe4-459a-8768-c1726138aeb6',
      location: 'The Post - 1805 E Cabrillo Blvd, Santa Barbara, CA 93108',
      timezone: 'America/Los_Angeles',
    },
    {
      id: 'san-francisco',
      name: 'San Francisco',
      eventTypeUri: 'https://api.calendly.com/event_types/050e07d4-477d-4ba0-bfd6-db845901fe5c',
      location: '3600 Sacramento St, San Francisco, CA 94118',
      timezone: 'America/Los_Angeles',
    },
  ];

  var TRUNK_SHOW_STORES = [
    {
    id: 'sample-event',
    name: 'Event Name - New York, NY',
    eventTypeUri: 'https://api.calendly.com/event_types/0f119c31-07ce-482a-937d-916c9667c539',
    location: '20 W 20th St, Ste 1004, New York, NY 10011',
    timezone: 'America/New_York',
    },

    {
    id: 'tea-oranges',
    name: 'Tea & Oranges',
    eventTypeUri: 'https://api.calendly.com/event_types/c3fd4a85-3da9-4851-92f8-1dda4c41dc84',
    location: '316 Springfield Ave, Summit, NJ 07901',
    timezone: 'America/New_York',
    },

    //PASTE FIRST CODE SNIPPET FROM THE EMAIL BEFORE THIS LINE!

  ];

  // ─── FACTORY ───────────────────────────────────────────────────────────────
  function createDrawer(config) {
    // config: { stores, drawerId, overlayId, eventName, globalName }
    var STORES       = config.stores;
    var DRAWER_ID    = config.drawerId;
    var OVERLAY_ID   = config.overlayId;
    var EVENT_NAME   = config.eventName;
    var PREFIX       = config.prefix;
    var AUTO_SELECT  = !!config.autoSelectFirstDate;

    // ── State ──
    var state = {
      currentYear: 0,
      currentMonth: 0,
      selectedDate: null,
      selectedSlot: null,
      availableSlots: {},
      slotCache: {},
      slotsLoading: false,
      store: STORES[0],
    };

    // ── Helpers ──
    var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var DAYS   = ['Su','Mo','Tu','We','Th','Fr','Sa'];

    function pad(n) { return String(n).padStart(2, '0'); }
    function toDateStr(yr, mo, dy) { return yr + '-' + pad(mo + 1) + '-' + pad(dy); }
    function el(id) { return document.getElementById(id); }
    function p(id) { return PREFIX + '-' + id; } // prefix helper: p('submit') → 'fsd-submit'
    function showEl(id) { var e = el(id); if (e) e.style.display = ''; }
    function hideEl(id) { var e = el(id); if (e) e.style.display = 'none'; }
    function setText(id, text) { var e = el(id); if (e) e.textContent = text; }

    function formatTime(iso, timezone) {
      var opts = { hour: 'numeric', minute: '2-digit', hour12: true };
      if (timezone) opts.timeZone = timezone;
      return new Intl.DateTimeFormat('en-US', opts).format(new Date(iso));
    }

    function ordinal(n) {
      var s = ['th','st','nd','rd'], v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    function formatButtonLabel() {
      if (!state.selectedSlot) return 'Book My Session';
      var tz = state.store.timezone;
      var d = new Date(state.selectedSlot);
      var parts = new Intl.DateTimeFormat('en-US', {
        month: 'long', day: 'numeric', timeZone: tz
      }).formatToParts(d);
      var month = parts.find(function(p) { return p.type === 'month'; }).value;
      var day   = ordinal(parseInt(parts.find(function(p) { return p.type === 'day'; }).value));
      var time  = formatTime(state.selectedSlot, tz).toLowerCase().replace(' ', '');
      return 'Book ' + month + ' ' + day + ' at ' + time;
    }

    function formatDisplayDate(iso, timezone) {
      var opts = { weekday: 'long', month: 'long', day: 'numeric' };
      if (timezone) opts.timeZone = timezone;
      return new Intl.DateTimeFormat('en-US', opts).format(new Date(iso));
    }

    function updateSubmitBtn() {
      var btn = el(p('submit'));
      if (btn && !btn.disabled) btn.textContent = formatButtonLabel();
    }

    function checkSubmitEnabled() {
      var btn = el(p('submit'));
      if (!btn) return;
      var phone = el(p('phone')) ? el(p('phone')).value.replace(/\D/g, '') : '';
      var email = el(p('email')) ? el(p('email')).value.trim() : '';
      var ready = !!(
        state.selectedDate &&
        state.selectedSlot &&
        el(p('first-name')) && el(p('first-name')).value.trim() &&
        el(p('last-name'))  && el(p('last-name')).value.trim() &&
        email && /\S+@\S+\.\S+/.test(email) &&
        phone.length === 10 &&
        el(p('bra-size'))  && el(p('bra-size')).value &&
        el(p('pant-size')) && el(p('pant-size')).value
      );
      btn.disabled = !ready;
      btn.textContent = ready ? formatButtonLabel() : 'Book My Session';
    }

    // ── Fetch availability ──
    var fetchGeneration = 0;

    function fetchSlots(year, month, store) {
      if (!store.eventTypeUri) return;
      // For trunk show (AUTO_SELECT), cache under 'all' since we fetch the full window at once
      var cacheKey = AUTO_SELECT ? 'all' : year + '-' + pad(month + 1);

      if (state.slotCache[cacheKey]) {
        fetchGeneration++;
        state.availableSlots = state.slotCache[cacheKey];
        state.slotsLoading = false;
        var calEl = document.getElementById(p('cal-grid')) && document.getElementById(p('cal-grid')).closest('.fsd-cal'); if (calEl) calEl.classList.remove('fsd-cal-loading');

        // Auto-select first available date on cache hit (trunk show mode)
        if (AUTO_SELECT && !state.selectedDate) {
          var today = new Date();
          var todayStr = toDateStr(today.getFullYear(), today.getMonth(), today.getDate());
          var allDates = Object.keys(state.availableSlots).sort();
          var firstDate = allDates.find(function(d) { return d >= todayStr && state.availableSlots[d].length > 0; });
          if (firstDate) {
            var parts = firstDate.split('-');
            var yr = parseInt(parts[0]), mo = parseInt(parts[1]) - 1;
            if (yr !== state.currentYear || mo !== state.currentMonth) {
              state.currentYear  = yr;
              state.currentMonth = mo;
            }
            selectDate(firstDate);
            return;
          }
        }

        renderCalendar();
        return;
      }

      var myGeneration = ++fetchGeneration;
      state.slotsLoading = true;
      state.availableSlots = {};
      var calEl = document.getElementById(p('cal-grid')) && document.getElementById(p('cal-grid')).closest('.fsd-cal'); if (calEl) calEl.classList.add('fsd-cal-loading');
      renderCalendar();

      var now = new Date();
      now.setMinutes(now.getMinutes() + 1);
      var startOfMonth = new Date(year, month, 1);
      // For trunk show mode, fetch the full 60-day window from NOW (not from currentMonth)
      // so switching to an earlier trunk show always finds its dates regardless of which
      // month the calendar is currently showing.
      var endOfWindow = AUTO_SELECT
        ? (function() { var d = new Date(); d.setDate(d.getDate() + 61); return d; })()
        : new Date(year, month + 1, 0, 23, 59, 59);
      var windowStart = AUTO_SELECT ? now : (startOfMonth > now ? startOfMonth : now);

      var newSlots = {};
      var fetches  = [];
      var cursor   = new Date(windowStart);

      while (cursor < endOfWindow) {
        var windowEnd = new Date(cursor);
        windowEnd.setDate(windowEnd.getDate() + 7);
        if (windowEnd > endOfWindow) windowEnd = new Date(endOfWindow);

        (function(start, end) {
          var params = new URLSearchParams({
            event_type: store.eventTypeUri,
            start_time: start.toISOString(),
            end_time:   end.toISOString(),
          });
          fetches.push(
            fetch(PROXY_BASE_URL + '/availability?' + params)
              .then(function(r) { return r.json(); })
              .then(function(data) {
                (data.collection || []).forEach(function(slot) {
                  var parts = new Intl.DateTimeFormat('en-US', {
                    year: 'numeric', month: '2-digit', day: '2-digit',
                    timeZone: store.timezone
                  }).formatToParts(new Date(slot.start_time));
                  var key = parts.find(function(p){return p.type==='year';}).value + '-'
                    + parts.find(function(p){return p.type==='month';}).value + '-'
                    + parts.find(function(p){return p.type==='day';}).value;
                  if (!newSlots[key]) newSlots[key] = [];
                  newSlots[key].push(slot.start_time);
                });
              })
          );
        })(new Date(cursor), new Date(windowEnd));

        cursor.setDate(cursor.getDate() + 7);
      }

      Promise.all(fetches)
        .then(function() {
          if (myGeneration !== fetchGeneration) return;
          state.availableSlots = newSlots;
          state.slotCache[cacheKey] = newSlots;

          // Auto-select the first available date (trunk show mode)
          if (AUTO_SELECT && !state.selectedDate) {
            var today = new Date();
            var todayStr = toDateStr(today.getFullYear(), today.getMonth(), today.getDate());
            var allDates = Object.keys(newSlots).sort();
            var firstDate = allDates.find(function(d) { return d >= todayStr && newSlots[d].length > 0; });
            if (firstDate) {
              // Navigate to the correct month if needed
              var parts = firstDate.split('-');
              var yr = parseInt(parts[0]), mo = parseInt(parts[1]) - 1;
              if (yr !== state.currentYear || mo !== state.currentMonth) {
                state.currentYear  = yr;
                state.currentMonth = mo;
              }
              selectDate(firstDate);
            }
          }
        })
        .catch(function(err) { console.error('Calendly fetch error:', err); })
        .finally(function() {
          if (myGeneration !== fetchGeneration) return;
          state.slotsLoading = false;
          var calEl = document.getElementById(p('cal-grid')) && document.getElementById(p('cal-grid')).closest('.fsd-cal'); if (calEl) calEl.classList.remove('fsd-cal-loading');
          renderCalendar();
        });
    }

    // ── Max date ──
    function getMaxMonth() {
      var today = new Date();
      var limit = new Date(today);
      limit.setDate(limit.getDate() + 60);
      return { year: limit.getFullYear(), month: limit.getMonth() };
    }

    // ── Render calendar ──
    function renderCalendar() {
      var year  = state.currentYear;
      var month = state.currentMonth;
      var today = new Date();
      var todayStr = toDateStr(today.getFullYear(), today.getMonth(), today.getDate());
      var max = getMaxMonth();

      setText(p('cal-title'), MONTHS[month] + ' ' + year);

      var prevBtn = el(p('cal-prev'));
      var nextBtn = el(p('cal-next'));

      // Only hide arrows once slots are loaded and confirmed single-month
      var slotDates = Object.keys(state.availableSlots);
      var singleMonth = !state.slotsLoading && slotDates.length > 0 && slotDates.every(function(d) {
        return d.slice(0, 7) === slotDates[0].slice(0, 7);
      });

      if (prevBtn) {
        prevBtn.disabled = (year === today.getFullYear() && month === today.getMonth());
        prevBtn.classList.toggle('fsd-hidden', AUTO_SELECT && singleMonth);
      }
      if (nextBtn) {
        nextBtn.disabled = (year === max.year && month === max.month);
        nextBtn.classList.toggle('fsd-hidden', AUTO_SELECT && singleMonth);
      }

      var grid = el(p('cal-grid'));
      if (!grid) return;
      grid.innerHTML = '';

      DAYS.forEach(function(d) {
        var cell = document.createElement('div');
        cell.className = 'fsd-cal-dow';
        cell.textContent = d;
        grid.appendChild(cell);
      });

      var firstDay    = new Date(year, month, 1).getDay();
      var daysInMonth = new Date(year, month + 1, 0).getDate();
      var limitDate   = new Date(); limitDate.setDate(limitDate.getDate() + 60);
      var limitStr    = limitDate.getFullYear() + '-'
        + String(limitDate.getMonth() + 1).padStart(2, '0') + '-'
        + String(limitDate.getDate()).padStart(2, '0');

      for (var i = 0; i < firstDay; i++) grid.appendChild(document.createElement('div'));

      for (var d = 1; d <= daysInMonth; d++) {
        var dateStr    = toDateStr(year, month, d);
        var isPast     = dateStr < todayStr;
        var isBeyond   = dateStr > limitStr;
        var hasSlots   = !!(state.availableSlots[dateStr] && state.availableSlots[dateStr].length);
        var isToday    = dateStr === todayStr;
        var isSelected = dateStr === state.selectedDate;
        var isDisabled = isPast || isBeyond || (!state.slotsLoading && !hasSlots);
        var noSlots    = !isPast && !isBeyond && !state.slotsLoading && !hasSlots;

        var btn = document.createElement('button');
        btn.className = 'fsd-cal-day';
        if (isToday)    btn.classList.add('today');
        if (isSelected) btn.classList.add('selected');
        if (noSlots)    btn.classList.add('no-slots');
        btn.textContent = d;
        btn.disabled = isDisabled;
        btn.setAttribute('aria-label', MONTHS[month] + ' ' + d + ', ' + year);

        if (!btn.disabled) {
          btn.addEventListener('click', (function(ds) {
            return function() { selectDate(ds); };
          })(dateStr));
        }
        grid.appendChild(btn);
      }
    }

    // ── Select date ──
    function selectDate(dateStr) {
      state.selectedDate = dateStr;
      state.selectedSlot = null;
      hideEl(p('err-date'));
      renderCalendar();
      renderSlots();
      checkSubmitEnabled();
    }

    // ── Render slots ──
    function renderSlots() {
      var section = el(p('time-section'));
      var grid    = el(p('slots-grid'));
      if (!section || !grid) return;
      section.style.display = '';
      grid.innerHTML = '';
      hideEl(p('slots-empty'));

      var slots = state.availableSlots[state.selectedDate] || [];
      if (!slots.length) { showEl(p('slots-empty')); return; }

      slots.forEach(function(iso) {
        var btn = document.createElement('button');
        btn.className = 'fsd-slot-btn' + (state.selectedSlot === iso ? ' selected' : '');
        btn.textContent = formatTime(iso, state.store.timezone);
        btn.addEventListener('click', function() {
          state.selectedSlot = iso;
          hideEl(p('err-slot'));
          renderSlots();
          checkSubmitEnabled();
        });
        grid.appendChild(btn);
      });
    }

    // ── Validate ──
    function validate() {
      var ok = true;
      function check(condition, errId, inputId) {
        var errEl   = errId   ? el(errId)   : null;
        var inputEl = inputId ? el(inputId) : null;
        if (!condition) {
          if (errEl)   errEl.style.display = '';
          if (inputEl) inputEl.classList.add('fsd-input-error');
          ok = false;
        } else {
          if (errEl)   errEl.style.display = 'none';
          if (inputEl) inputEl.classList.remove('fsd-input-error');
        }
      }
      check(state.selectedDate, p('err-date'),       null);
      check(state.selectedSlot, p('err-slot'),       null);
      check(el(p('first-name')) && el(p('first-name')).value.trim(), p('err-first-name'), p('first-name'));
      check(el(p('last-name'))  && el(p('last-name')).value.trim(),  p('err-last-name'),  p('last-name'));
      var email = el(p('email')) ? el(p('email')).value.trim() : '';
      check(email && /\S+@\S+\.\S+/.test(email), p('err-email'), p('email'));
      var phone = el(p('phone')) ? el(p('phone')).value.replace(/\D/g, '') : '';
      check(phone.length === 10, p('err-phone'), p('phone'));
      check(el(p('bra-size'))  && el(p('bra-size')).value,  p('err-bra-size'),  p('bra-size'));
      check(el(p('pant-size')) && el(p('pant-size')).value, p('err-pant-size'), p('pant-size'));
      return ok;
    }

    // ── Submit ──
    function submit() {
      if (!validate()) return;
      var submitBtn = el(p('submit'));
      submitBtn.disabled = true;
      submitBtn.textContent = 'Booking\u2026';
      hideEl(p('form-error'));

      var firstName = el(p('first-name')).value.trim();
      var lastName  = el(p('last-name')).value.trim();
      var email     = el(p('email')).value.trim();
      var phone     = el(p('phone')).value.replace(/\D/g, '');
      var phoneE164 = phone.length === 10 ? '+1' + phone : null;
      var braSize   = el(p('bra-size')).value;
      var pantSize  = el(p('pant-size')).value;
      var notes     = el(p('notes')).value.trim();

      var payload = {
        event_type: state.store.eventTypeUri,
        start_time: state.selectedSlot,
        invitee: {
          name:     firstName + ' ' + lastName,
          email:    email,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || state.store.timezone,
        },
        location: {
          kind:     'physical',
          location: state.store.location,
        },
        questions_and_answers: [
          { position: 0, question: 'Bra Size',  answer: braSize },
          { position: 1, question: 'Pant Size', answer: pantSize },
          ].concat(notes ? [{ position: 2, question: "Any styles you're dying to try? Destinations you're headed to? Let us know!", answer: notes }] : []),
      };
      if (phoneE164) payload.invitee.text_reminder_number = phoneE164;

      fetch(PROXY_BASE_URL + '/book', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
      .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
      .then(function(res) {
        if (!res.ok) throw new Error(res.data.message || res.data.title || 'Booking failed. Please try again.');
        setText(p('confirm-email'),    email);
        setText(p('confirm-location'), 'Malia Mills ' + state.store.name);
        setText(p('confirm-date'),     formatDisplayDate(state.selectedSlot, state.store.timezone));
        setText(p('confirm-time'),     formatTime(state.selectedSlot, state.store.timezone));
        setText(p('confirm-name'),     firstName + ' ' + lastName);
        hideEl(DRAWER_ID + '-form');
        showEl(DRAWER_ID + '-success');
      })
      .catch(function(err) {
        var errEl = el(p('form-error'));
        if (errEl) { errEl.textContent = err.message; errEl.style.display = ''; }
        submitBtn.disabled = false;
        submitBtn.textContent = formatButtonLabel();
      });
    }

    // ── Reset ──
    function resetForm() {
      state.selectedDate = null;
      state.selectedSlot = null;
      state.availableSlots = {};
      state.slotCache = {};

      hideEl(DRAWER_ID + '-success');
      showEl(DRAWER_ID + '-form');
      hideEl(p('time-section'));

      [p('err-date'),p('err-slot'),p('err-first-name'),p('err-last-name'),
       p('err-email'),p('err-phone'),p('err-bra-size'),p('err-pant-size'),p('form-error')].forEach(hideEl);

      [p('first-name'),p('last-name'),p('email'),p('phone'),p('notes')].forEach(function(id) {
        var e = el(id); if (e) e.value = '';
      });
      [p('bra-size'),p('pant-size')].forEach(function(id) {
        var e = el(id); if (e) e.selectedIndex = 0;
      });
      [p('first-name'),p('last-name'),p('email'),p('phone'),p('bra-size'),p('pant-size')].forEach(function(id) {
        var e = el(id); if (e) e.classList.remove('fsd-input-error');
      });

      var submitBtn = el(p('submit'));
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Book My Session'; }

      renderCalendar();
    }

    // ── Open / Close ──
    function open(storeId) {
      var drawer  = el(DRAWER_ID);
      var overlay = el(OVERLAY_ID);
      if (!drawer) return;

      if (storeId) {
        var store = STORES.find(function(s) { return s.id === storeId; });
        if (store && store.id !== state.store.id) {
          state.store = store;
          state.selectedDate = null;
          state.selectedSlot = null;
          state.availableSlots = {};
          state.slotCache = {};
          var select = el(p('store-select'));
          if (select) select.value = storeId;
          checkSubmitEnabled();
        } else if (store) {
          var select = el(p('store-select'));
          if (select) select.value = storeId;
        }
      }

      drawer.classList.add('fsd-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.classList.add('fsd-open');
      document.body.classList.add('fsd-body-lock');
      drawer.focus();

      var cacheKey = state.currentYear + '-' + pad(state.currentMonth + 1);
      if (!state.slotCache[cacheKey]) {
        fetchSlots(state.currentYear, state.currentMonth, state.store);
      }
    }

    function close() {
      var drawer  = el(DRAWER_ID);
      var overlay = el(OVERLAY_ID);
      if (!drawer) return;
      drawer.classList.remove('fsd-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('fsd-open');
      document.body.classList.remove('fsd-body-lock');
      setTimeout(resetForm, 380);
    }

    // ── Init ──
    function init() {
      var drawer  = el(DRAWER_ID);
      var overlay = el(OVERLAY_ID);
      // Suppress transition on initial paint so the drawer doesn't animate in from off-screen
      if (drawer)  drawer.classList.add('fsd-no-transition');
      if (overlay) overlay.classList.add('fsd-no-transition');

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          if (drawer)  drawer.classList.remove('fsd-no-transition');
          if (overlay) overlay.classList.remove('fsd-no-transition');
        });
      });
      
      var today = new Date();
      state.currentYear  = today.getFullYear();
      state.currentMonth = today.getMonth();

      var submitBtn = el(p('submit'));
      if (submitBtn) submitBtn.disabled = true;

      renderCalendar();
      fetchSlots(state.currentYear, state.currentMonth, state.store);

      // Nav buttons
      var prevBtn = el(p('cal-prev'));
      if (prevBtn) prevBtn.addEventListener('click', function() {
        if (state.currentMonth === 0) { state.currentMonth = 11; state.currentYear--; }
        else state.currentMonth--;
        state.selectedDate = null; state.selectedSlot = null;
        hideEl(p('time-section'));
        checkSubmitEnabled();
        fetchSlots(state.currentYear, state.currentMonth, state.store);
      });

      var nextBtn = el(p('cal-next'));
      if (nextBtn) nextBtn.addEventListener('click', function() {
        var max = getMaxMonth();
        if (state.currentYear === max.year && state.currentMonth === max.month) return;
        if (state.currentMonth === 11) { state.currentMonth = 0; state.currentYear++; }
        else state.currentMonth++;
        state.selectedDate = null; state.selectedSlot = null;
        hideEl(p('time-section'));
        checkSubmitEnabled();
        fetchSlots(state.currentYear, state.currentMonth, state.store);
      });

      // Store selector
      var storeSelect = el(p('store-select'));
      if (storeSelect) {
        storeSelect.addEventListener('change', function() {
          var store = STORES.find(function(s) { return s.id === this.value; }, this);
          if (!store) return;
          state.store = store;
          state.selectedDate = null; state.selectedSlot = null;
          state.availableSlots = {}; state.slotCache = {};
          hideEl(p('time-section'));
          checkSubmitEnabled();
          fetchSlots(state.currentYear, state.currentMonth, state.store);
        });
      }

      // Close buttons
      var closeBtn = el(DRAWER_ID + '-close');
      if (closeBtn) closeBtn.addEventListener('click', close);
      var doneBtn = el(DRAWER_ID + '-done');
      if (doneBtn) doneBtn.addEventListener('click', close);

      // Overlay
      var overlay = el(OVERLAY_ID);
      if (overlay) overlay.addEventListener('click', close);

      // Submit
      var submitBtnEl = el(p('submit'));
      if (submitBtnEl) submitBtnEl.addEventListener('click', submit);

      // Phone formatter
      var phoneInput = el(p('phone'));
      if (phoneInput) {
        phoneInput.addEventListener('input', function() {
          var digits = this.value.replace(/\D/g, '').slice(0, 10);
          var formatted = '';
          if (digits.length > 0) formatted = '(' + digits.slice(0, 3);
          if (digits.length >= 4) formatted += ') ' + digits.slice(3, 6);
          if (digits.length >= 7) formatted += '-' + digits.slice(6, 10);
          this.value = formatted;
          if (digits.length === 10) {
            this.classList.remove('fsd-input-error');
            hideEl(p('err-phone'));
          }
          checkSubmitEnabled();
        });
      }

      // Live error clearing
      [p('first-name'),p('last-name'),p('email')].forEach(function(id) {
        var input = el(id);
        if (input) input.addEventListener('input', function() {
          if (this.value.trim()) {
            this.classList.remove('fsd-input-error');
            hideEl(PREFIX + '-err-' + id.replace(PREFIX + '-', ''));
          }
          checkSubmitEnabled();
        });
      });
      [p('bra-size'),p('pant-size')].forEach(function(id) {
        var input = el(id);
        if (input) input.addEventListener('change', function() {
          if (this.value) {
            this.classList.remove('fsd-input-error');
            hideEl(PREFIX + '-err-' + id.replace(PREFIX + '-', ''));
          }
          checkSubmitEnabled();
        });
      });

      // ESC
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && el(DRAWER_ID) && el(DRAWER_ID).classList.contains('fsd-open')) close();
      });

      // Custom event
      document.addEventListener(EVENT_NAME, function(e) {
        open(e.detail && e.detail.storeId ? e.detail.storeId : null);
      });
    }

    // Wait for DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    return { open: open, close: close };
  }

  // ─── CREATE INSTANCES ──────────────────────────────────────────────────────
  window.FitSessionDrawer = createDrawer({
    stores:    FIT_SESSION_STORES,
    drawerId:  'fit-session-drawer',
    overlayId: 'fit-session-overlay',
    eventName: 'fit-session:open',
    prefix:    'fsd',
  });

  window.TrunkShowDrawer = createDrawer({
    stores:               TRUNK_SHOW_STORES,
    drawerId:             'trunk-show-drawer',
    overlayId:            'trunk-show-overlay',
    eventName:            'trunk-show:open',
    prefix:               'tsd',
    autoSelectFirstDate:  true,
  });

})();